import { CurrentEntryPoint } from '../../constants/CurrentEntryPoint';
import { Api } from '../../api/Api';

let $languageSelect: JQuery<HTMLDivElement>;
const OPEN_CLASS = 'open';

$(function() {
    $languageSelect = $('#language_select');

    $languageSelect.on('click', function() {
        const $language_list = $languageSelect.find('.language_list');

        if ($language_list.hasClass(OPEN_CLASS)) {
            $language_list.removeClass(OPEN_CLASS);
        } else {
            $language_list.addClass(OPEN_CLASS);
        }
    });

    $languageSelect.on('mouseleave', function() {
        $languageSelect.find('.language_list').removeClass(OPEN_CLASS);
    });

    $('.language_list a').on('click', function() {
        Api.post('setLanguage', {}, {
            lang: $(this).find('li')
                .data('lang')
        });
    });

    if (
        window.app.config.current_entry_point === CurrentEntryPoint.FB ||
        window.app.config.current_entry_point === CurrentEntryPoint.FB2
    ) {
        $('.language_list a').on('click', function() {
            const url = $(this).attr('href');
            const $form = $('#changeFacebookLanguage');

            $form.attr('action', url);
            $form.submit();
            return false;
        });
    }
});
